import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null, // вместо userEmail
  userEmail: ''
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    logout: (state) => {
      state.user = null;
    },
  },
});

export const { setUser, logout, setUserEmail } = authSlice.actions;

export const selectUser = (state) => state.auth.user;
export const selectUserEmail = (state) => state.auth.userEmail;

export default authSlice.reducer;
